export default __webpack_public_path__ + "static/media/Scene 9 (2).cfdfa349.webp";